import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../../../config';

const appApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: config.API_URL }),
  tagTypes: [
    'UserReferrals',
    'ReferralMilestones',
    'ReferralMultiplier',
    'MultiplayerPersonas',
    'CoverLetters',
  ],
  endpoints: () => ({}),
});

export default appApi;
